<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3 handle-bottom">
            <el-form :inline="true" class="demo-form-inline">
              <div class="uers-right uers-right-buttom">
              <span class="btn-r">
                <el-button
                    type="primary"
                    plain
                    icon="el-icon-plus"
                    @click="addSubmit"
                >新增
                </el-button>
              </span></div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="table"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
                  width="100"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="banner"
                  label="图片"
                  width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.banner"
                        :preview-src-list="[scope.row.banner]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="ticket"
                  label="投票次数"
                  width="100"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ '每' + scope.row.day + '天' + scope.row.ticket + '票' }}</p>
                  <p>{{ '总计:' + scope.row.total + '票' }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="url" width="250" label="Url地址" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.url }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="isVerify"
                  label="投票权限"
                  width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.isVerify === 0 ? "登录" : scope.row.isVerify === 1 ? "分论坛权限" : "分论坛权限" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="look"
                  label="查看权限"
                  width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.look === 0 ? "登录" : scope.row.isVerify === 1 ? "分论坛权限" : "分论坛权限" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="showTicket"
                  label="展示票数"
                  width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.showTicket == 0 ? "否" : "是" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="disabled"
                  label="状态"
                  width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.disabled == 0 ? "启用" : "禁用" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="创建时间"
                  width="180"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="有效时间"
                  width="180"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.startDate }}</p>
                  <p>{{ scope.row.endDate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      @click="handleManage(scope.$index, scope.row)"
                  >管理
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditVote
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditVote>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditVote from "../../components/major/EditVote";
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      voteId: "",
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.getData();
    },
    addSubmit() {
      this.voteId = "";
      this.listShow = false;
      this.editShow = true;
      this.editData = null;
    },
    handleDelete(index, row) {
      this.voteId = row.voteId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.voteId = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/Vote/${this.voteId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    // 获取数据
    getData() {
      this.$axios.post("/Vote/Search/", {projectId: this.projectId}).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleManage(index, row) {
      this.$router.push("/vote_item?id=" + row.voteId);
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.editData = null;
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditVote,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-right {
  float: right;
}

.uers-right-buttom {
  margin-bottom: 19px;
}

.handle-bottom {
  padding-bottom: 20px;
}

.import-bnt {
  float: right;
}

.el-upload--text {
  border: 0;
}
</style>